import axios from 'axios'
import interceptorsSetup from '@/helpers/interceptors'

const baseURL = process.env.VUE_APP_API_URL_NEW + '/assistant'

const assistant = axios.create({
  baseURL
})

interceptorsSetup(assistant)

export default class Assistance {
  static async chat ({ message, history }) {
    const { data } = await assistant.post('/chat', {
      message,
      history
    })
    return data
  }
}
